'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'narwhal';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'f6fe';
var svgPathData = 'M638.6 22.6L562.4 190.1c46.8 31.6 77.6 85.2 77.6 145.9 0 97.2-78.8 176-176 176l-224 0c-63.7 0-118.7-37.2-144.5-91.1-7.8-16.3-12.9-34.1-14.8-52.9-.5-5.3-.8-10.6-.8-16l0-88-80-40 0-128 96 48 96-48 0 128-80 40 0 104 .9-.7 31.1-23.8 179.5-137.3c39.2-30 87.2-46.2 136.6-46.2l3.9 0c25 0 48.8 5.2 70.3 14.6L609.4 9.4 638.6 22.6zM240 480l224 0c79.5 0 144-64.5 144-144S543.5 192 464 192l-3.9 0c-42.3 0-83.5 13.9-117.1 39.7l-211.5 161.8-9.8 7.5c19.2 46.4 65 79.1 118.3 79.1zM504 272a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM110.3 172.6L96 179.8c-3.6-1.8-25-12.5-64-32l0 56.4 64 32 64-32 0-56.4-49.7 24.8z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faNarwhal = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;